import React, { useEffect, useMemo, useRef, useState } from 'react';
import { Button, ButtonPriority, Text, TextTypography, } from 'wix-ui-tpa/cssVars';
import styles from './form-loading-error.module.scss';
import { DATA_HOOKS } from '../data-hooks';
import { TRANSLATIONS_NAMESPACE } from '../../../constants/translations';
const FormLoadingError = ({ formId, i18n, translations, locale = 'en', onError, isRTL, }) => {
    const t = useMemo(() => i18n.getFixedT(locale, TRANSLATIONS_NAMESPACE), [locale, i18n]);
    useState(() => i18n.addResources(locale, TRANSLATIONS_NAMESPACE, translations));
    const isError = useRef(false);
    useEffect(() => {
        if (!isError.current) {
            isError.current = true;
            onError?.(new Error(`Couldn’t load the form: ${formId}`));
        }
        return () => {
            isError.current = false;
        };
    }, [formId, onError]);
    return (React.createElement("div", { className: styles.container, "data-hook": DATA_HOOKS.FORM_VIEWER_NO_FORM_ERROR, dir: isRTL ? 'rtl' : '' },
        React.createElement(Text, { typography: TextTypography.smallTitle }, t?.('error.could-not-load-form.title')),
        React.createElement(Text, { typography: TextTypography.runningText }, t('error.could-not-load-form.description')),
        React.createElement(Button, { className: styles.button, onClick: () => window.location.reload(), priority: ButtonPriority.primary }, t?.('error.could-not-load-form.button.label'))));
};
export default FormLoadingError;
//# sourceMappingURL=form-loading-error.js.map